/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import PropTypes from 'prop-types';
export default function IconArrowRight({ className }){
  return (
    <svg
      className={className}
      fill="none"
      height="24"
      viewBox="0 0 25 24"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2045 4.28377C13.8111 3.89615 13.178 3.90084 12.7904 4.29424C12.4027 4.68765 12.4074 5.3208 12.8008 5.70842L18.1712 10.9998H4.5C3.94771 10.9998 3.5 11.4475 3.5 11.9998C3.5 12.5521 3.94772 12.9998 4.5 12.9998H18.1646L12.8008 18.2847C12.4074 18.6723 12.4027 19.3055 12.7904 19.6989C13.178 20.0923 13.8111 20.097 14.2045 19.7094L21.1287 12.887C21.6256 12.3974 21.6256 11.5958 21.1287 11.1062L14.2045 4.28377Z"
        fill="currentColor"
      />
    </svg>
  );
}
IconArrowRight.propTypes = {
  className: PropTypes.string
};
